<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="600px"
    destroy-on-close
    custom-class="error-dialog"
    title="服务调用异常"
  >
    <div class="short-info">
      <i class="el-icon-warning error-icon" />
      服务调用异常，请联系管理员！
    </div>
    <el-button
      type="text"
      class="show-detail-btn"
      @click="showDetail(!isShowDetail)"
      >查看详细信息</el-button
    >
    <div v-if="isShowDetail" class="detail-info">
      <div class="detail-title">
        错误代码：<span class="detail-content">{{ errorInfo.errorCode }}</span>
      </div>
      <div class="detail-title detail-errormsg">
        错误信息：<span class="detail-content">{{ errorInfo.errorMsg }}</span>
      </div>

      <div class="detail-title">异常堆栈：</div>
      <div v-html="errorStackInfo" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-clipboard:copy="JSON.stringify(errorInfo)"
        v-clipboard:success="clipboardSuccessHandler"
        >复制错误信息</el-button
      >
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ServerErrorInfoWnd',
  data() {
    return {
      dialogVisible: false,
      errorInfo: {},
      isShowDetail: false
    }
  },
  computed: {
    errorStackInfo() {
      return this.errorInfo.errorStack
        ? this.errorInfo.errorStack.replace(/\n/g, '<br/>')
        : ''
    }
  },
  methods: {
    showError(errObj) {
      this.errorInfo = errObj
      this.isShowDetail = false
      this.dialogVisible = true
    },
    showDetail(isShow) {
      this.isShowDetail = isShow
    },
    clipboardSuccessHandler() {
      //   this.$alert('已经复制到粘贴板。', '', {
      //     confirmButtonText: '确定'
      //   });
      this.$message({
        message: '已经复制到粘贴板。',
        type: 'success'
      })
      //   window.clipboardData.setData('Text', JSON.stringify(this.errorInfo))
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.detail-info {
  max-height: 400px;
  overflow: auto;
  white-space: nowrap;
}
.detail-title {
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 4px;
}
.detail-errormsg {
  max-height: 60px;
  overflow: hidden;
}
.detail-content {
  font-weight: normal;
}
.show-detail-btn {
  margin-left: 10px;
}
.short-info {
  font-size: 14px;
  margin-bottom: 10px;
  .error-icon {
    font-size: 28px;
    color: rgb(182, 182, 2);
    vertical-align: -4px;
    // line-height: 14px;
  }
}
/deep/ .error-dialog {
  .el-dialog__header {
    padding: 6px 20px 6px;
    background-color: rgb(214, 70, 70);
  }
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    font-weight: normal;
  }
  .el-dialog__headerbtn {
    top: 6px;
    .el-dialog__close {
      color: #fff;
    }
  }
}
</style>
